import {
  ANNUALLY,
  MONTHLY,
  SelectableBillingPeriodTypes
} from '@constants/billingPeriods'
import { useUserContext } from '@contexts/user'
import { useCalcDatesForPromotion } from '@hooks/useCalcDatesForPromotion'
import { BLACK_FRIDAY, PROMOTION_FOR_FREE_PLAN, useSale } from '@hooks/useSale'
import { useCountdown } from '@ui-kit'

export const PROMOTION_KEYS = [PROMOTION_FOR_FREE_PLAN, BLACK_FRIDAY] as const

export type PromotionKey = (typeof PROMOTION_KEYS)[number]

export const useGetPromotions = ({
  price,
  billingPeriod
}: {
  price?: number
  billingPeriod: SelectableBillingPeriodTypes
}): Record<PromotionKey, { isVisible: boolean; price: number | undefined }> => {
  const promotion = useSale()

  const { isTypeClient, user } = useUserContext()

  const { date, promotionIsVisible } = useCalcDatesForPromotion()

  const { isFinished } = useCountdown(date)

  const isInSQLStage = user?.platform_stage === 'SQL'

  const isVisiblePromotionForFreePlan =
    promotion === PROMOTION_FOR_FREE_PLAN &&
    billingPeriod === MONTHLY &&
    isInSQLStage &&
    !isTypeClient &&
    !isFinished &&
    promotionIsVisible

  const isVisibleBlackFridayPromotion =
    promotion === BLACK_FRIDAY && billingPeriod === ANNUALLY

  const prices = price
    ? {
        [PROMOTION_FOR_FREE_PLAN]: price * 0.5,
        [BLACK_FRIDAY]: (price * 12 - 400) / 12
      }
    : {}

  return {
    [PROMOTION_FOR_FREE_PLAN]: {
      isVisible: isVisiblePromotionForFreePlan,
      price: prices[PROMOTION_FOR_FREE_PLAN]
    },
    [BLACK_FRIDAY]: {
      isVisible: isVisibleBlackFridayPromotion,
      price: prices[BLACK_FRIDAY]
    }
  }
}
